module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/201.f320757e.png";